// IAS-specific browser storage helpers used by the SSO provider and login flow
// to track "user has already signed into Metabase after SSO" and login-in-progress
// state. Kept out of Redux because they need to survive full page reloads during
// the OIDC redirect dance.

import type { User } from "metabase-types/api";

import { LOCAL_STORAGE_APP_USER_ITEM_KEY } from "./constants";

export function hasMetabaseUserInfo() {
  return !!localStorage.getItem(LOCAL_STORAGE_APP_USER_ITEM_KEY);
}

export function persistMetabaseUserInfo(user: User) {
  localStorage.setItem(LOCAL_STORAGE_APP_USER_ITEM_KEY, JSON.stringify(user));
}

export function removeMetabaseUserInfo() {
  localStorage.removeItem(LOCAL_STORAGE_APP_USER_ITEM_KEY);
}

export function isLoggingIn() {
  return sessionStorage.getItem("is_logging_in") === "true";
}

export function persistIsLoggingIn() {
  sessionStorage.setItem("is_logging_in", "true");
}

export function removeIsLoggingIn() {
  sessionStorage.removeItem("is_logging_in");
}

export function isSiteSettingsLoadedSuccessfully() {
  return sessionStorage.getItem("site_settings_loaded_successfully") === "true";
}

export function persistIsSiteSettingsLoadedSuccessfully() {
  sessionStorage.setItem("site_settings_loaded_successfully", "true");
}
